import React from 'react';
import Message from 'components/commercetools-ui/atoms/message';

interface Props {
  errorText: string;
}

const AmazonSessionError: React.FC<Props> = ({ errorText }) => {
  return (
    <>
      <div className="relative bg-white p-25 pt-40 lg:w-[100%]">
        <Message severity={'error'} message={errorText}></Message>
      </div>
    </>
  );
};

export default AmazonSessionError;
